'use strict';

require("core-js/modules/es.array.flat");

require("core-js/modules/es.array.unscopables.flat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmartTextInput = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uniqueId = require('lodash/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _themr = require('react-css-themr/lib/components/themr');

var _themr2 = _interopRequireDefault(_themr);

var _identifiers = require('../../../identifiers');

var _emojiMart = require('emoji-mart');

var _Spinner = require('../../../elements/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // UI


var SmartTextInput = function (_React$Component) {
  _inherits(SmartTextInput, _React$Component);

  function SmartTextInput() {
    _classCallCheck(this, SmartTextInput);

    var _this = _possibleConstructorReturn(this, (SmartTextInput.__proto__ || Object.getPrototypeOf(SmartTextInput)).call(this));

    _this.tooltipId = (0, _uniqueId2['default'])('tooltip-');
    _this.focusInput = _this.focusInput.bind(_this);
    return _this;
  }

  _createClass(SmartTextInput, [{
    key: 'focusInput',
    value: function focusInput() {
      var inputRef = this.props.inputRef;
      inputRef.current.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          theme = _props.theme,
          valid = _props.valid,
          pristine = _props.pristine,
          optional = _props.optional,
          tall = _props.tall,
          editable = _props.editable,
          loading = _props.loading,
          emoji = _props.emoji,
          onEmojiClick = _props.onEmojiClick,
          style = _props.style;
      var emojiButtonClass = (0, _classnames2['default'])(theme.emoji, 'preventClickOutside');
      return _react2['default'].createElement('div', {
        className: this.wrapperClass,
        style: style
      }, emoji && _react2['default'].createElement('u', {
        className: emojiButtonClass,
        onClick: editable ? onEmojiClick : this.focusInput
      }, _react2['default'].createElement(_emojiMart.Emoji, {
        size: 20,
        emoji: emoji,
        native: true
      })), optional && valid && pristine && _react2['default'].createElement('u', {
        className: theme.optional,
        onClick: this.focusInput
      }, '(optional)'), loading && valid && _react2['default'].createElement('u', {
        className: theme.spinner
      }, _react2['default'].createElement(_Spinner2['default'], {
        size: tall ? 'small' : 'tiny'
      })), valid === false && _react2['default'].createElement('u', {
        className: theme.exclamationMark
      }), _react2['default'].createElement('input', this.innerInputProps));
    }
  }, {
    key: 'innerInputProps',
    get: function get() {
      var _cn;

      var _props2 = this.props,
          theme = _props2.theme,
          className = _props2.className,
          tall = _props2.tall,
          optional = _props2.optional,
          pristine = _props2.pristine,
          valid = _props2.valid,
          emoji = _props2.emoji,
          flat = _props2.flat,
          editable = _props2.editable,
          loading = _props2.loading,
          color = _props2.color,
          align = _props2.align,
          placeholder = _props2.placeholder,
          inputRef = _props2.inputRef,
          type = _props2.type,
          rest = _objectWithoutProperties(_props2, ['theme', 'className', 'tall', 'optional', 'pristine', 'valid', 'emoji', 'flat', 'editable', 'loading', 'color', 'align', 'placeholder', 'inputRef', 'type']);

      var cleanProps = (0, _omit2['default'])(rest, ['autocomplete', 'initialValues', 'onEmojiClick', 'wrapperClassName', 'noInteraction', 'autoFill', 'position']);
      return _extends({
        className: (0, _classnames2['default'])(className, theme.input, (_cn = {}, _defineProperty(_cn, theme.tall, tall), _defineProperty(_cn, theme.optional, optional && pristine), _defineProperty(_cn, theme.invalid, valid === false), _defineProperty(_cn, theme.emoji, emoji), _defineProperty(_cn, theme.flat, flat), _defineProperty(_cn, theme.editable, editable), _defineProperty(_cn, theme.loading, loading), _defineProperty(_cn, theme[color], color), _defineProperty(_cn, theme.alignLeft, align === 'left'), _defineProperty(_cn, theme.alignCenter, align === 'center'), _cn)),
        ref: inputRef,
        type: type,
        pattern: type === 'number' ? '[0-9]*' : undefined,
        placeholder: placeholder
      }, cleanProps);
    }
  }, {
    key: 'wrapperClass',
    get: function get() {
      var _cn2;

      var _props3 = this.props,
          wrapperClassName = _props3.wrapperClassName,
          theme = _props3.theme,
          editable = _props3.editable,
          tall = _props3.tall,
          valid = _props3.valid,
          position = _props3.position,
          noInteraction = _props3.noInteraction;
      return (0, _classnames2['default'])(wrapperClassName, theme.wrapper, (_cn2 = {}, _defineProperty(_cn2, theme.editable, editable), _defineProperty(_cn2, theme.tall, tall), _defineProperty(_cn2, theme.invalid, valid === false), _defineProperty(_cn2, theme[position], position), _defineProperty(_cn2, theme.noInteraction, !editable && noInteraction), _cn2));
    }
  }]);

  return SmartTextInput;
}(_react2['default'].Component);

SmartTextInput.defaultProps = {
  valid: true,
  pristine: true,
  optional: false,
  flat: false,
  tall: false,
  editable: false,
  align: 'left',
  loading: false,
  placeholder: 'Placeholder',
  noInteraction: false,
  inputRef: _react2['default'].createRef(),
  position: 'default'
};
SmartTextInput.propTypes = {
  theme: _propTypes2['default'].object.isRequired,
  valid: _propTypes2['default'].bool.isRequired,
  pristine: _propTypes2['default'].bool.isRequired,
  optional: _propTypes2['default'].bool,
  flat: _propTypes2['default'].bool,
  tall: _propTypes2['default'].bool,
  autoFill: _propTypes2['default'].bool,
  editable: _propTypes2['default'].bool.isRequired,
  color: _propTypes2['default'].oneOf(['primary', 'success', 'warning', 'danger', undefined]),
  align: _propTypes2['default'].oneOf(['left', 'center', 'right']),
  loading: _propTypes2['default'].bool,
  emoji: _propTypes2['default'].string,
  wrapperClassName: _propTypes2['default'].string,
  placeholder: _propTypes2['default'].string.isRequired,
  onEmojiClick: _propTypes2['default'].func,
  noInteraction: _propTypes2['default'].bool,
  inputRef: _propTypes2['default'].object.isRequired,
  position: _propTypes2['default'].oneOf(['default', 'start', 'end', 'lonely']).isRequired,
  type: _propTypes2['default'].oneOf(['text', 'email', 'number', 'tel', 'url', 'password', 'search', 'phone']).isRequired
};
var themed = (0, _themr2['default'])(_identifiers.SMART_FORM_TEXT_INPUT)(SmartTextInput);
exports.SmartTextInput = SmartTextInput;
exports['default'] = themed;